import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShare2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.25 7a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M9.25 12a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M19.25 17a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0M14.5 16 9 13.5M14.5 8.5 9 11"
    />
  </svg>
);
export default SvgShare2;
